import React from 'react';

const defaultContext = {
  hasContext: false,
  close: () => {},
  print: () => {},
};

const ModalContext = React.createContext({ ...defaultContext });

export default ModalContext;
